module.exports = __webpack_public_path__ + "img/dwarf-robot-wars.9822824b.jpg";